import React, { useState, useRef } from "react";
import axios from "axios";
var er1 = false;

function ForgotPass(props) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const emailField = useRef("");

  const handleLogin = (e) => {
    e.preventDefault();

    var a = emailField.current.value;

    if (!a.includes("@") || !a.includes(".")) {
      er1 = true;
      setError("That's not a valid email format");

      // document.getElementById("er").style.color='red'  ;
    } else {
      er1 = false;

      let url =
        process.env.REACT_APP_API_BASE_URL +
        "passwordReset?email=" +
        a +
        "&notify=true";

      axios
        .get(url)
        .then((r) => {
          setError(
            "If this is a valid email, we will send an email to your email address"
          );
        })
        .catch((r) => {
          setError(
            "If this is a valid email, we will send an email to your email address"
          );
        });
    }
  };

  return (
    <body>
      <div class="container">
        <div class="row">
          <div class="col-sm-9 col-md-7 col-lg-6 mx-auto mt-4">
            <div style={{ position: "absolute", top: "-10px", right: "-80px" }}>
              <img
                alt="Kapitalwise"
                src={require("assets/img/login_top_back.svg")}
              />
            </div>
            <div
              class="card my-5 border border-1"
              style={{
                borderColor: "#A6ABC9",
                borderRadius: "20px",
                zIndex: "1",
              }}
            >
              <div class="card-body p-5">
                <div className="d-flex justify-content-center align-items-center p-2">
                  <img
                    alt="Kapitalwise"
                    src={require("assets/img/logo.svg")}
                    style={{ width: "3em", height: "3em" }}
                  />{" "}
                  <span className="nav_brand_text">Kapitalwise</span>
                </div>
                <div className="login_title d-flex justify-content-center align-items-center p-2">
                  <text>Change your Kapitalwise password</text>
                </div>
                <div className="login_create_new d-flex justify-content-center align-items-center p-2">
                  <text>Enter your email to reset your password</text>
                </div>

                <form onSubmit={handleLogin}>
                  <div
                    class="form-floating mb-3"
                    style={{ lineHeight: "35px" }}
                  >
                    <text className="text-label-1">Email</text>
                    <input
                      type="email"
                      class="form-control m-0"
                      id="floatingInput"
                      ref={emailField}
                    />
                    {error &&
                      (er1 ? (
                        <>
                          <small id="er" style={{ color: "red" }}>
                            {error}
                          </small>
                          <br />
                        </>
                      ) : (
                        <>
                          <small id="er" style={{ color: "green" }}>
                            {error}
                          </small>
                          <br />
                        </>
                      ))}
                  </div>

                  <div class="login_btn">
                    <button class="xl_btn primary w_100 mt-2" type="submit">
                      {loading ? "Loading..." : "Submit"}
                    </button>
                  </div>
                  {/* <div class="form-check d-flex justify-content-center align-items-center mt-3">
                    <div>
                      <input type="checkbox" value="" />
                      <text
                        class="login_create_new "
                        for="rememberPasswordCheck"
                      >
                        keep me logged in
                      </text>
                    </div>
                  </div> */}
                </form>
              </div>
            </div>
            <div style={{ position: "absolute", bottom: "0px", left: "-40px" }}>
              <img
                alt="Kapitalwise"
                src={require("assets/img/login_bottom_back.svg")}
              />
            </div>
          </div>
        </div>
      </div>
    </body>
  );
}

export default ForgotPass;
